import { gql } from '@apollo/client';
import { leasingExpenseTypeFragment } from './fragments';

export const LEASING_EXPENSE_TYPES_QUERY = gql`
  query leasingExpenseTypes($pager: PagerInputNew, $filters: LeasingExpenseTypeFilterInput) {
    leasingExpenseTypes(pager: $pager, filters: $filters) {
      total
      values {
        expenseTypeId
        expenseName
        expenseCode
        currencyId
        currencyCode
        currencyPercent
        currencyValue
        isActive
      }
    }
  }
`;

export const LEASING_EXPENSE_TYPE_QUERY = gql`
  query leasingExpenseType($expenseTypeId: Int!) {
    leasingExpenseType(expenseTypeId: $expenseTypeId) {
      ...leasingExpenseType
    }
  }
  ${leasingExpenseTypeFragment}
`;
